<template>
    <div class="footer">
        <div class="footer-header">
            <div></div>
            <div @click="handleToTop" class="goTop">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" role="presentation" class="icon-base_root-F1flk footer-header-row_scrollTop-mZCMO" width="16" height="16" data-icon="scroll-top"><path fill-rule="evenodd" d="M2.1 2a.9.9 0 0 1 .9-.9h9.021a.9.9 0 1 1 0 1.8H3a.9.9 0 0 1-.9-.9m4.51 5.161v6.84a.9.9 0 1 0 1.8 0V7.156l2.181 2.19a.9.9 0 0 0 1.276-1.27L8.151 4.347a.9.9 0 0 0-.638-.265H7.51c-.27 0-.513.12-.678.308L3.156 8.077A.9.9 0 1 0 4.43 9.348z" clip-rule="evenodd"></path></svg>
            </div>
        </div>
        <div class="classify">
            <div class="classify-sub hide" :class="{ 'act': act1 }" @click="act1 = !act1">
                <h4 class="classify-sub-title arrow botArrow">Cassino</h4>
                <div class="classify-sub-list">
                    <div v-for="(item, index) in gameClassify" :key="index" class="classify-sub-item" @click="toCasino(item)">{{ item.categoryShowName }}</div>
                </div>
            </div>
            <div class="classify-sub hide" :class="{ 'act': act2 }" @click="act2 = !act2">
                <h4 class="classify-sub-title arrow botArrow">Actividad</h4>
                <div class="classify-sub-list">
                    <div class="classify-sub-item" @click="onNavToByIsLogin({ url: '/vip' })">VIP</div>
                    <div class="classify-sub-item" @click="onNavTo({ url: '/Affiliate' })">Agente</div>
                </div>
            </div>
            <div class="classify-sub hide" :class="{ 'act': act3 }" @click="act3 = !act3">
                <h4 class="classify-sub-title arrow botArrow">Suporte</h4>
                <div class="classify-sub-list">
                    <div class="classify-sub-item" @click="onNavTo({ url: '/notification', type: 'get', params: { type: 0 } })">Servir</div>
                    <div class="classify-sub-item" @click="onNavTo({ url: '/notification', type: 'get', params: { type: 2 } })">Notificar</div>
                </div>
            </div>
            <div class="desc">
                <img class="logo" :src="logoUrl" />
                <!-- <div class="desc-content">{{ sysConfig.explainDec }}</div> -->
                <div class="desc-content">
                    <div>1. Este producto est¡ destinado a personas mayores de 18 anos y es solopara fines de entretenimiento.</div>
                    <div>2. Este juego contiene compras dentro de la aplicación.</div>
                    <div>3. El hecho de que un jugador juegue o gane en un juego de apuestassociales no significa que vaya a ganar en apuestas con dinero real yjuegos relacionados en el futuro.</div>
                </div>
                <div class="desc-logos">
                    <img v-for="(item, index) in friendLogoList" :key="index" :src="item.imageUrl" />
                    <img src="@/assets/home/footer-icon-3.png" />
                </div>
                <div class="copyright">{{ sysConfig.copyright }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant'
import { getFriendLogoList } from '@/api/home'
import { getGameClassify } from '@/api/game'
export default {
    name: 'Footer',
    data() {
        return {
            act1: false,
            act2: false,
            act3: false,
            pathAct: '',
            friendLogoList: [],
            gameClassify: []
        }
    },
    computed: {
        logoUrl() {
            return this.$store.getters.sysConfig?.homeLogoUrl
        },
        sysConfig() {
            return this.$store.getters.sysConfig || {}
        }
    },
    watch: {
        $route: {
            handler: function (to, from) {
                this.pathAct = this.$route.name
            },
            deep: true
        }
    },
    created() {
        this.pathAct = this.$route.name
        this.getFriendLogoList()
        this.getGameClassify()
    },
    methods: {
        getGameClassify() {
            getGameClassify().then(res => {
                const that = this
                if (res.code) return
                const D = res.result.filter(x => x.gameTitleIPage && x.gameTitleIPage.records && x.gameTitleIPage.records.length && x.gameCategoryType !== 'None')
                const obj1 = {
                    id: 'Popular',
                    activationImg: require('@/assets/home/icon_hotAct.webp'),
                    unActivationImg: require('@/assets/home/icon_hotAct.webp'),
                    categoryShowName: this.$t('home.Popular'),
                    gameCategoryType: 'Popular',
                    favPageNum: 0,
                    favList: [],
                    RecentList: [],
                    hotPageNum: 1,
                    hotList: []
                }
                D.unshift(obj1)
                const obj2 = {
                    id: 'Recent',
                    activationImg: require('@/assets/home/icon_recentAct.webp'),
                    unActivationImg: require('@/assets/home/icon_recentAct.webp'),
                    categoryShowName: this.$t('home.Recent'),
                    gameCategoryType: 'Recente',
                    RecentPageNum: 0,
                    RecentList: []
                }
                D.push(obj2)
                const obj3 = {
                    id: 'Favoritos',
                    activationImg: require('@/assets/home/icon_favAct.webp'),
                    unActivationImg: require('@/assets/home/icon_favAct.webp'),
                    categoryShowName: this.$t('home.Favorite'),
                    gameCategoryType: 'Favoritos',
                    favPageNum: 0,
                    favList: []
                }
                D.push(obj3)
                that.gameClassify = D
            })
        },
        async getFriendLogoList(info, index) {
            const {
                result,
                code
            } = await getFriendLogoList()
            if (code === 0) {
                this.friendLogoList = result
            }
        },
        handleToTop(top) {
            const scrollEle = document.getElementById('AppMain') /* // .app-main是盒子的最高父级 */
            scrollEle.scrollTo({
                top,
                behavior: 'smooth'
            })
        },
        onMenuItem(act) {
            if (this.pathAct === act) {
                Toast(this.$t('lang.CurrentlyPage'))
                return
            }
            this.pathAct = act
            this.onNavTo({ url: act, type: 'post' })
        },
        toCasino(item) {
            const obj = {
                iconImg: item.activationImg,
                code: item.gameCategoryType,
                title: item.gameCategoryType,
                gamePlatformType: item.gamePlatformType,
                // gameTitleId: item.id,
                gameFactoryName: item.gameFactoryName
            }
            // console.log(obj)
            const params = encodeURIComponent(JSON.stringify(obj))
            const timestamp = new Date().getTime()
            this.onNavTo({ url: 'SubGame', type: 'post', params: { timestamp, params } })
        }
    }
}
</script>

<style lang="scss" scoped>
.footer {
    width: 100%;
    // background: #1d2027;
    box-sizing: border-box;
    padding-top: 35px;
    padding-bottom: 50px;
}

.footer-header {
    margin: 0 auto;
    // max-width: 1414px;
    min-width: 720px;
    padding-left: 31px;
    padding-right: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    & > div:nth-child(1){
        flex: 1;
        height: .01rem;
        margin: 0 .2rem;
        background: rgba(223, 183, 112, 0.18);
        margin-left: 0;
    }

    .goTop{
        background: linear-gradient(180deg, rgba(135, 13, 18, .96) 0%, rgba(92, 6, 10, .98) 100%);
        border: .01rem solid rgba(203, 136, 61, .36);
        border-radius: .2rem;
        padding: .19rem .2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: .08rem;
        cursor: pointer;

        svg{
            fill: #efd8ad;
        }
    }
}

.classify {
    width: 100%;
    display: flex;
    // column-gap: 5%;
    margin: 0 auto;
    margin-top: .1rem;
    min-width: 720px;
    padding-left: 32px;
    padding-right: 32px;
    width: 100%;

    .classify-sub {
        width: 160px;

        .classify-sub-title {
            width: 100%;
            color: #d7b37d;
            text-transform: uppercase;
            margin-bottom: .3rem;
            text-align: left;
        }

        .classify-sub-list {
            font-size: 14px;
            text-align: left;

            .classify-sub-item {
                color: #E5E8E9;
                line-height: .24rem;
                font-size: .26rem;
                margin-bottom: .32rem;
                cursor: pointer;

                &:hover {
                    color: #fff;
                }

                &.act {
                    color: #fff;
                }
            }
        }
    }
}

.desc {
    flex: 1;
    text-align: left;
    width: 100%;
    // column-gap: 5%;
    margin: 0 auto;
    max-width: 1414px;
    min-width: 720px;
    padding-left: 32px;
    padding-right: 32px;
    gap: 1.2rem;

    .desc-content{
        color: #d9be95;
        font-size: .26rem;
        font-weight: bold;
    }
    .desc-logos{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: .2rem;
        flex-wrap: wrap;
        padding-top: .32rem;

        & > img{
            height: .68rem;
            width: auto;
            vertical-align: middle;
            margin-bottom: .28rem;
        }
    }

    .logo {
        height: .98rem;
        width: auto;
        margin-bottom: .24rem;
    }
    .copyright{
        width: 100%;
        text-align: center;
        color: #fff;
        font-size: .25rem;
        font-weight: bold;
    }
}
</style>
